module.exports = __webpack_public_path__ + "img/science-primary-700.27f10766.svg";